// ABOUTME: The slot picker's Request for platform3: Appy calls with the session's auth headers
// ABOUTME: A response that does not decode is a contract defect and is reported; others are logged
import { warn } from '@execonline-inc/logging';
import { Request, RequestSpec, SlotPickerError } from '@execonline-inc/slot-picker.private';
import { AppyError, callApi } from '../../Appy';
import { warnAndNotify } from '../../Honeybadger';

const toSlotPickerError =
  (href: string) =>
  (error: AppyError): SlotPickerError => {
    if (error.kind === 'bad-payload') {
      // A fixed message keeps one Honeybadger fault per defect; the href names the course.
      warnAndNotify(
        'CoachingSchedulerDecodeError',
        'Coaching scheduler response failed to decode',
        {
          href,
          error,
        },
      );
    } else {
      warn('CoachingSchedulerRequestFailed', href, error.kind);
    }
    return { message: error.kind };
  };

const payloadOf = (spec: RequestSpec): object => {
  switch (spec.kind) {
    case 'get': {
      return {};
    }
    case 'post': {
      return spec.body;
    }
  }
};

export const request: Request = (href, spec, decoder) =>
  callApi(decoder, payloadOf(spec), {
    rel: 'coaching-scheduler',
    href,
    method: spec.kind,
    type: 'application/json',
  }).mapError(toSlotPickerError(href));
